module.exports = __webpack_public_path__ + "fonts/a5867750f234125a1f0bb26e5ea50f98-Roboto-BlackItalic.eot";